import axios from 'axios';

import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';

export type BannerMessageType = 'warning' | 'outage';

export type RawBannerMessage = {
  id: number;
  message: string;
  type: BannerMessageType;
  messageStartTime: string;
  messageEndTime: string;
  eventStartTime: string;
  eventEndTime: string;
  applications: string[];
};

export type OutageBannerResponse = {
  pollInterval: number;
  messages: RawBannerMessage[];
};

// TODO: replace with environment-based URL for production
const OUTAGE_BANNER_URL = '/public/mock/site-banner.json';

const outageBannerService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchOutageBanner: builder.query<OutageBannerResponse, void>({
      queryFn: async () => {
        try {
          const { data } =
            await axios.get<OutageBannerResponse>(OUTAGE_BANNER_URL);

          return { data };
        } catch (_err) {
          return {
            error: { status: 500, data: null, message: 'Fetch failed' },
          };
        }
      },
    }),
  }),
});

export const { useFetchOutageBannerQuery } = outageBannerService;
